import { IconWarningMS } from '@/constants/icons';

import {
  ButtonsContainer,
  CancelButton,
  ConfirmButton,
  Footnote,
  Message,
  StyledDialog,
  WarningBox,
} from './styles';

interface ConfirmDialogProps {
  open: boolean;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  warning?: string;
  footnote?: string;
}

export function ConfirmDialog({
  open,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  warning,
  footnote,
}: ConfirmDialogProps): JSX.Element {
  return (
    <StyledDialog open={open} onClose={onCancel}>
      <Message>{message}</Message>
      {warning && (
        <WarningBox>
          {IconWarningMS}
          {warning}
        </WarningBox>
      )}
      <ButtonsContainer>
        <CancelButton onClick={onCancel}>{cancelLabel}</CancelButton>
        <ConfirmButton onClick={onConfirm}>{confirmLabel}</ConfirmButton>
      </ButtonsContainer>
      {footnote && <Footnote>{footnote}</Footnote>}
    </StyledDialog>
  );
}
